import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OptionFormTypes } from '../../../../services/filtering/filter-form-render-service/option-form-types';
import { renderFormBasedOnType } from '../../../../services/filtering/filter-form-render-service/';

export const State = {
  id: 'state',
  displayName: <FormattedMessage defaultMessage='State' description='filterOptions.state' id='qSxY2U' />,
  type: OptionFormTypes.TYPE_IS_OR_ISNOT_MULTI_OPTIONS,
  filterValue: 'state',
  expectsArgumentAsArray: true,

  render: (criteriaInformations, existingFiltersHelpers) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_IS_OR_ISNOT_MULTI_OPTIONS, criteriaInformations, existingFiltersHelpers);
  },
};
